<template>
    <v-form
        v-model="internal_valid"
        @submit.prevent
    >
        <v-text-field
            v-model="internal_input"
            :hint="hint"
            :label="label"
            :max="max"
            :min="min"
            :placeholder="placeholder"
            :rules="rules"
            :type="type"
            variant="outlined"
        />
    </v-form>
</template>

<script>
export default {
    name: 'TextField',
    props: {
        max: {
            type: String,
            default: null,
        },
        min: {
            type: String,
            default: null,
        },
        input: {
            type: String,
        },
        valid: {
            type: Boolean,
        },
        label: {
            type: String,
            default: '',
        },
        placeholder: {
            type: String,
            default: '',
        },
        hint: {
            type: String,
            default: '',
        },
        type: {
            type: String,
            default: 'text',
        },
        rules: {
            type: Array,
            default: () => [],
        },
    },
    mixins: [],
    components: {},
    emits: ['update:input', 'update:valid'],
    data() {
        return {}
    },
    computed: {
        internal_input: {
            get() {
                return this.input
            },
            set(value) {
                this.$emit('update:input', value)
            },
        },
        internal_valid: {
            get() {
                return this.valid
            },
            set(value) {
                this.$emit('update:valid', value)
            },
        },
    },
    watch: {},
    methods: {},
    beforeCreate() {},
    created() {},
    beforeMount() {},
    mounted() {},
    beforeUpdate() {},
    updated() {},
    beforeUnmount() {},
}
</script>

<style scoped lang="sass">
:deep(input::-webkit-outer-spin-button),
:deep(input::-webkit-inner-spin-button)
    -webkit-appearance: none
    margin: 0

:deep(input[type=number])
    -moz-appearance: textfield
</style>
